import type { ClassType } from "@vlab-corporation/vlab-pilates-service-interface/class";
import type {
  EquipmentType,
  ExerciseEntry,
} from "@vlab-corporation/vlab-pilates-service-interface/class";

export interface JournalDraft {
  classType: ClassType | undefined;
  isOt: boolean;
  equipments: EquipmentType[];
  exercises: ExerciseEntry[];
  problemList: string;
  improvements: string;
  improvementsNeeded: string;
  notes: string;
  bodyAnalysis: string;
  memberGoal: string;
  instructorMemo: string;
  savedAt: string;
}

function getDraftKey(centerId: number, classId: string): string {
  return `journalDraft:${centerId}:${classId}`;
}

export function useJournalDraft(centerId: number, classId: string | undefined) {
  const key = classId ? getDraftKey(centerId, classId) : null;

  function saveDraft(draft: Omit<JournalDraft, "savedAt">): boolean {
    if (!key) return false;
    try {
      const data: JournalDraft = { ...draft, savedAt: new Date().toISOString() };
      localStorage.setItem(key, JSON.stringify(data));
      return true;
    } catch {
      return false;
    }
  }

  function loadDraft(): JournalDraft | null {
    if (!key) return null;
    try {
      const raw = localStorage.getItem(key);
      if (!raw) return null;
      return JSON.parse(raw) as JournalDraft;
    } catch {
      return null;
    }
  }

  function clearDraft(): void {
    if (!key) return;
    try {
      localStorage.removeItem(key);
    } catch {
      // ignore errors
    }
  }

  return { saveDraft, loadDraft, clearDraft };
}
